var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"charging-mode"},[_c('span',{staticClass:"homepage-title"},[_vm._v("告警占比")]),_c('div',{staticStyle:{"width":"100%","height":"95%"},attrs:{"id":"charging-mode"}})])
}]

export { render, staticRenderFns }